
import { defineComponent, reactive, ref, watch } from "vue";
import {
  Roles,
  Users,
} from "@/store/enums/StoreEnums";
import { hideModal } from "@/core/helpers/dom";
import { useStore } from "vuex";
import {
  ElMessage,
  ElMessageBox,
  FormInstance,
  FormRules,
  UploadFiles,
} from "element-plus";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { CookieComponent } from "@/assets/ts/components/_CookieComponent";
import moment from "moment";

interface DataForm {
  nMaTaiKhoan: string | null,
  cMatKhau: string | null,
  /* nMaCuaHang: number | null, */
  cTenTaiKhoan: string | null,
  cHoTen: string | null,
  cQuyenHeThong: string | null,
  nMaNhomQuyen: number | null,
  nTinhTrang: number | null,
  cEmail: string | null,
  cSoDienThoai: string | null,
  cNguoiTao: string | null,
  dNgayTao: string | null,
  cNguoiCapNhatCuoi: string | null,
  dNgayCapNhatCuoi: string | null,
  dNgayBatDau: string | null,
  dNgayKetThuc: string | null,
}

export default defineComponent({
  name: "kt-modal-accounts",
  props: {
    data: Object,
    default: Object,
    RoleList: Array,
    size: String,
    shops: Array,
    operation: Boolean
  },
  emits: ["finishPW", "finish"],
  components: {},
  watch: {
    
  },
  setup(props) {
    const accountModalRef = ref<null | HTMLElement>(null);
    const passwordForm = ref({
      nMaTaiKhoan: "",
      newPassword: "",
      confirmPassword: "",
    });
    const passwordFormRef = ref<FormInstance>()
    const defaultValues = reactive<DataForm>(props.default as DataForm)
    const validateForm = reactive<DataForm>(props.data as DataForm);
    const validateFormRef = ref<FormInstance>();
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Bạn chưa nhập mật khẩu mới"));
      } else {
        if (passwordForm.value.confirmPassword !== "") {
          validateFormRef.value?.validateField("Xác nhận mật khẩu");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Bạn chưa nhập mật khẩu xác nhận"));
      } else if (value !== passwordForm.value.newPassword) {
        callback(new Error("Mật khẩu không trùng khớp"));
      } else {
        callback();
      }
    };
    const rules = ref({
      /* oldPassword: [
        {
          required: true,
          message: "Bạn chưa nhập mật khẩu cũ",
          trigger: "blur",
        },
      ], */
      newPassword: [
        { required: true, message: "Bạn chưa nhập mật khẩu mới", trigger: "blur" },
        { validator: validatePass, trigger: "blur" },
        { min: 6, message: "Mật khẩu tối thiểu 6 ký tự" },
      ],
      confirmPassword: [
        { required: true, message: "Bạn chưa nhập xác nhận mật khẩu", trigger: "blur" },
        { validator: validatePass2, trigger: "blur" }
      ],
      cTenTaiKhoan: [
        {
          required: true,
          message: "Bạn chưa nhập tên tài khoản",
          trigger: "blur",
        },
      ],
      cMatKhau: [
        { required: true, message: "Bạn chưa nhập mật khẩu" },
        { min: 6, message: "Mật khẩu tối thiểu 6 ký tự" },
      ],
      cHoTen: [
        { required: true, message: "Bạn chưa nhập họ tên", trigger: "blur" },
      ],
      nMaNhomQuyen: [
        {
          required: true,
          message: "Bạn chưa chọn quyền hệ thống",
          trigger: "blur",
        },
      ],

      cEmail: [
        {
          type: "email",
          message: "Bạn phải nhập đúng địa chỉ Email",
          trigger: "blur",
        },
      ],
    })

    const clearForm = (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      formEl.resetFields();
    };

    const store = useStore()

    return {
      passwordForm,
      validateForm,
      validateFormRef,
      accountModalRef,
      clearForm,
      rules,
      store,
      defaultValues,
      passwordFormRef
    }
  },

  methods: {
    handleSave() {
      this.validateFormRef?.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.validateForm);
          this.store.dispatch(Users.saveUser, params).then((res) => {
            if (res.code == 200) {
              if (!this.operation) {
                ElMessage({
                  message: "Thêm tài khoản thành công!",
                  type: "success",
                });
              } else {
                ElMessage({
                  message: "Cập nhật tài khoản thành công!",
                  type: "success",
                });
              }
              this.$emit("finish");
              this.validateFormRef?.resetFields();
              this.passwordFormRef?.resetFields();
              hideModal(this.accountModalRef);
            } else {
              if (!this.operation) {
                ElMessage({
                  message: "Thêm tài khoản thất bại!",
                  type: "error",
                });
              } else {
                ElMessage({
                  message: "Cập nhật tài khoản thất bại!",
                  type: "error",
                });
              }
            }
          }).catch(error => {
            if (!this.operation) {
              ElMessage({
                message: "Thêm tài khoản thất bại!",
                type: "error",
              });
            } else {
              ElMessage({
                message: "Cập nhật tài khoản thất bại!",
                type: "error",
              });
            }
          });
        }
      });
    },
    handleClose() {
      /*       let DV = this.defaultValues as DataForm;
            let DF = this.validateForm;
            let check = false;
            for (let prop in DF) {
              check = false;
              if (DF[prop] != DV[prop] && prop != "nMaNhomQuyen") {
                check=true
                break;
              }
            }
      
            if (check) {
              ElMessageBox.confirm(
                "Những thay đôi của bạn sẽ không được lưu lại, bạn có chắc muốn thoát ?"
              )
                .then(async () => {
                  await this.clearForm(this.validateFormRef);
                  hideModal(this.accountModalRef);
                })
                .catch((err) => {
                  console.log(err);
                });
            } else { */
      this.passwordFormRef?.resetFields();
      hideModal(this.accountModalRef);
      /* } */
    },
    changePass() {
      this.passwordForm.nMaTaiKhoan = this.validateForm.nMaTaiKhoan as string
      this.store.dispatch(Users.changePassword, this.passwordForm).then(res => {
        if (res.code == 200) {
          this.$emit("finish");
          this.validateFormRef?.resetFields();
          this.passwordFormRef?.resetFields();
          hideModal(this.accountModalRef);
          ElMessage({
            message: "Đổi mật khẩu thành công",
            type: "success"
          })
        }
      })
    }
  },
});
